/** @jsxImportSource @emotion/react */

import { useEffect, useState } from 'react'
import { Box, Dialog, useTheme } from '@mui/material'
import releaseNotesMd from '../../../../../release-notes.md?raw'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { MarkdownStyle } from '@app/components/Atoms/UiMarkdown/UiMarkdown.styles'
import rehypeRaw from 'rehype-raw'
import { DATADOG_ACTIONS } from '@app/app-constants'
import { logDataDogAction } from '@app/utils/logger'
import {
  content,
  contentParent,
  footer,
  HeaderContainer,
  versionMenu,
  versionsButton,
} from './ReleaseNotesModal.styles'

// Parse markdown once at module level to avoid re-parsing. We're loading the
// markdown anyway, there is no to lazy loading it:
const parsedMarkdown = releaseNotesMd.split(/\n# /).map((item) => {
  return {
    title: item.split('\n')[0].replace('# ', ''),
    content: item.split('\n').slice(1).join('\n').trim(),
  }
})

export const ReleaseNotesModal = ({
  open,
  handleClose,
}: {
  open: boolean
  handleClose: (arg0: boolean) => void
}) => {
  const theme = useTheme()
  const [selectedPost, setSelectedPost] = useState<number>(0)
  const [menuVisible, setMenuVisible] = useState<boolean>(false)

  useEffect(() => {
    if (!open) return
    logDataDogAction(DATADOG_ACTIONS.NOTIFICATIONS_VIEWED)
  }, [open])

  return (
    <Dialog open={open} onClose={() => handleClose(false)}>
      <Box css={HeaderContainer({ theme })}>
        <h1>Release Notes</h1>
        <Box css={versionsButton(theme, menuVisible)} onClick={() => setMenuVisible(!menuVisible)}>
          {menuVisible ? <ChevronRight /> : <ChevronLeft />}
          <span>Previous Versions</span>
        </Box>
      </Box>
      <Box css={contentParent}>
        <Box css={content(theme)}>
          <h2>{parsedMarkdown[selectedPost].title}</h2>
          <Markdown css={MarkdownStyle} remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
            {parsedMarkdown[selectedPost].content}
          </Markdown>
        </Box>
        <Box css={versionMenu(theme, menuVisible)}>
          {parsedMarkdown.map((item, index) => (
            <Box
              onClick={() => setSelectedPost(index)}
              className={selectedPost == index ? 'selected' : ''}
              key={index}
            >
              {item.title}
            </Box>
          ))}
        </Box>
      </Box>
      <Box css={footer(theme)}>
        <img src="/logos/UILogoFullWhite.svg" alt="uintel logo" />
      </Box>
    </Dialog>
  )
}
